import React from 'react';
import { useTranslation } from '../contexts/TranslationContext';

const Impressum = () => {
    const { t } = useTranslation();

    return (
        <div className="bg-white">
            {/* Hero Section - Mobile optimized */}
            <section className="relative min-h-[40vh] sm:h-[50vh] flex items-center justify-center bg-gradient-to-br from-primary-50 via-white to-accent-50 overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-r from-primary-900/10 via-transparent to-accent-900/10"></div>
                <div className="container-custom relative z-10 text-center pt-20 sm:pt-24 px-4">
                    <h1 className="text-3xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-neutral-950 mb-4 sm:mb-6 leading-tight">
                        {t('imprint.title')}
                    </h1>
                    <p className="text-base sm:text-xl md:text-2xl text-neutral-700 max-w-3xl mx-auto leading-relaxed">
                        {t('imprint.description')}
                    </p>
                </div>
            </section>

            {/* Content - Mobile optimized */}
            <section className="section-padding bg-neutral-50">
                <div className="container-custom">
                    <div className="max-w-4xl mx-auto bg-white rounded-xl sm:rounded-2xl shadow-md sm:shadow-lg border border-gray-100 p-5 sm:p-8 md:p-12">
                        <div className="space-y-8 sm:space-y-10">
                            {/* Company Information */}
                            <section>
                                <h3 className="text-xl sm:text-2xl font-semibold text-neutral-950 mb-3 sm:mb-4">
                                    {t('imprint.companyInfo')}
                                </h3>
                                <div className="text-neutral-700 leading-relaxed text-base sm:text-lg">
                                    <p className="font-medium">{t('imprint.companyName')}</p>
                                    <div className="whitespace-pre-line mt-2">
                                        {t('imprint.address')}
                                    </div>
                                </div>
                            </section>

                            {/* Contact */}
                            <section>
                                <h3 className="text-xl sm:text-2xl font-semibold text-neutral-950 mb-3 sm:mb-4">
                                    {t('imprint.contact')}
                                </h3>
                                <div className="text-neutral-700 leading-relaxed space-y-1 text-base sm:text-lg">
                                    <p>{t('imprint.phone')}</p>
                                    <p className="break-all">{t('imprint.email')}</p>
                                    <p>{t('imprint.web')}</p>
                                </div>
                            </section>

                            {/* Legal Information */}
                            <section>
                                <h3 className="text-xl sm:text-2xl font-semibold text-neutral-950 mb-3 sm:mb-4">
                                    {t('imprint.legalInfo')}
                                </h3>
                                <div className="text-neutral-700 leading-relaxed space-y-1 text-base sm:text-lg">
                                    <p>{t('imprint.managingDirector')}</p>
                                    <p>{t('imprint.registrationCourt')}</p>
                                    <p>{t('imprint.commercialRegister')}</p>
                                    <p className="break-all">{t('imprint.vatId')}</p>
                                    <p className="break-all">{t('imprint.fiscalCode')}</p>
                                    <p>{t('imprint.recipientCode')}</p>
                                    <p>{t('imprint.economicRegistry')}</p>
                                </div>
                            </section>

                            {/* Business Activity */}
                            <section>
                                <h3 className="text-xl sm:text-2xl font-semibold text-neutral-950 mb-3 sm:mb-4">
                                    {t('imprint.businessActivity')}
                                </h3>
                                <p className="text-neutral-700 leading-relaxed text-base sm:text-lg">
                                    {t('imprint.businessActivityText')}
                                </p>
                            </section>

                            {/* Authorizations */}
                            <section>
                                <h3 className="text-xl sm:text-2xl font-semibold text-neutral-950 mb-3 sm:mb-4">
                                    {t('imprint.authorizations')}
                                </h3>
                                <p className="text-neutral-700 leading-relaxed text-base sm:text-lg">
                                    {t('imprint.authorizationsText')}
                                </p>
                            </section>

                            {/* Responsibility */}
                            <section>
                                <h3 className="text-xl sm:text-2xl font-semibold text-neutral-950 mb-3 sm:mb-4">
                                    {t('imprint.responsibility')}
                                </h3>
                                <div className="text-neutral-700 leading-relaxed text-base sm:text-lg">
                                    <p>{t('imprint.responsibilityText')}</p>
                                    <p className="mt-2 font-medium">{t('imprint.editorialResponsibility')}</p>
                                </div>
                            </section>

                            {/* Data Protection Officer */}
                            <section>
                                <h3 className="text-xl sm:text-2xl font-semibold text-neutral-950 mb-3 sm:mb-4">
                                    Datenschutzbeauftragter / Responsabile Protezione Dati / Data Protection Officer
                                </h3>
                                <p className="text-neutral-700 leading-relaxed text-base sm:text-lg break-all">
                                    {t('imprint.dataProtectionOfficer')}
                                </p>
                            </section>


                            {/* Copyright */}
                            <section>
                                <h3 className="text-xl sm:text-2xl font-semibold text-neutral-950 mb-3 sm:mb-4">
                                    {t('imprint.copyrightNotice')}
                                </h3>
                                <p className="text-neutral-700 leading-relaxed text-base sm:text-lg">
                                    {t('imprint.copyrightText')}
                                </p>
                            </section>

                            {/* Dispute Resolution */}
                            <section>
                                <h3 className="text-xl sm:text-2xl font-semibold text-neutral-950 mb-3 sm:mb-4">
                                    {t('imprint.disputeResolution')}
                                </h3>
                                <p className="text-neutral-700 leading-relaxed text-base sm:text-lg">
                                    {t('imprint.disputeResolutionText')}
                                </p>
                            </section>

                            {/* Disclaimer */}
                            <section>
                                <h3 className="text-xl sm:text-2xl font-semibold text-neutral-950 mb-3 sm:mb-4">
                                    {t('imprint.disclaimer')}
                                </h3>
                                <p className="text-neutral-700 leading-relaxed text-base sm:text-lg">
                                    {t('imprint.disclaimerText')}
                                </p>
                            </section>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Impressum;
